<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;
}

.left-arrow {
  color: #666666;
}

.company-info {
  display: flex;

  margin: 0.24rem 0;
  padding: 0.48rem 0.1rem 0.44rem 0.3rem;

  background-color: #fff;

  flex-flow: row nowrap;

  .shop-logo {
    width: 1.04rem;
    height: 1.04rem;
    overflow: hidden;

    border-radius: 0.08rem;

    flex: none;

    img {
      width: 100%;

      border-radius: 100%;
    }
  }
  .shop-content {
    display: flex;

    margin-left: 0.36rem;
    overflow: hidden;

    flex: auto;
    flex-direction: column;
    p {
      color: #333333;
    }
    .shop-title {
      margin-bottom: 0.12rem;

      font-size: 0.32rem;
      font-weight: 700;

      .shop-qualification-btn {
        display: inline-flex;

        width: 1.4rem;
        height: 0.4rem;
        margin-left: 0.04rem;

        background: #0daf52;
        border-radius: 2px;

        justify-content: center;
        align-items: center;

        font-size: 0.24rem;

        text-shadow: none;
        .icon {
          width: 0.16rem;
          height: 0.22rem;

          margin-right: 0.04rem;
        }
      }
    }
    .shop-desc {
      display: -webkit-box;

      min-width: 0;

      /* autoprefixer: on */
      overflow: hidden;

      font-size: 0.24rem;

      text-overflow: ellipsis;

      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
    }
  }
}

.license {
  display: flex;

  position: relative;

  height: 0.88rem;
  padding: 0 0.3rem;

  background-color: #fff;

  flex-flow: row nowrap;

  justify-content: space-between;
  align-items: center;

  font-size: 0.28rem;
  color: #262626;
  &.person-shopinfo {
    display: flex;

    height: 1.28rem;

    padding: 0 0.3rem;

    background-color: #fff;

    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .sub-text {
    margin-top: 0.04rem;

    font-size: 0.24rem;
    color: #8c8c8c;
  }

  &.biz-class {
    height: auto;
    margin-top: 0.24rem;
    & > p {
      line-height: 0.88rem;
    }
    &:after {
      display: none;
    }
  }

  &:after {
    display: block;

    position: absolute;
    bottom: 0;
    left: 0.3rem;

    width: calc(100% - 0.3rem);
    height: 1px;

    background-color: #ddd;
    opacity: 0.4;

    content: '';
  }
  .right-icon {
    color: #8c8c8c;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
}
</style>

<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      'background-color': '#fff',
      height: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="nav-bar"
      left-arrow
      :title="title"
      :safe-top-distance="statusBarHeight"
      @click-left="goBack"
    />
    <scroll-view :with-bottom="false" :background="'#F5F5F5'">
      <div class="company-info">
        <div class="shop-logo">
          <img :src="shop.logoUrl" :alt="shop.name" />
        </div>
        <div class="shop-content">
          <p class="shop-title">{{ shop.name }}</p>
          <p class="shop-desc">简介：{{ shop.desc }}</p>
        </div>
      </div>
      <ul v-if="!personShopInfo.isPersonShop" class="licenses">
        <li
          v-if="qualification.showBizLicense"
          class="license"
          @click="goLicense('biz')"
        >
          <p>营业执照</p>
          <p>
            <span class="meicai-icon-right-arrow right-icon"></span>
          </p>
        </li>
        <li
          v-for="license in qualification.otherLicenses"
          :key="license.type"
          class="license"
          @click="goLicense(license.type)"
        >
          <p>{{ license.name }}</p>
          <p>
            <span class="meicai-icon-right-arrow right-icon"></span>
          </p>
        </li>
      </ul>

      <ul v-if="personShopInfo.isPersonShop" class="licenses">
        <li
          v-if="personShopInfo.showPersonShopDetail"
          class="license"
          @click="goPersonShopInfo"
        >
          <p>商家经营信息</p>
          <p>
            <span class="meicai-icon-right-arrow right-icon"></span>
          </p>
        </li>
        <li
          v-if="!personShopInfo.showPersonShopDetail"
          class="license person-shopinfo"
        >
          <p>商家经营信息</p>
          <p class="sub-text">{{ personShopInfo.personalTip }}</p>
        </li>
      </ul>

      <div v-if="bizClassText" class="license biz-class">
        <p>当前经营范围：{{ bizClassText }}</p>
      </div>
    </scroll-view>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { miniProgramEnv } from '@/defines/environment'
import ScrollView from '@/common/widgets/scroll_view'
import Url from '@mc/mc-utils/js/url/url'
export default {
  name: 'ShopQualification',
  components: {
    ScrollView
  },
  beforeRouteEnter(to, from, next) {
    const url = new Url(window.location.href)
    const query = url.parseQuerystring()
    const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

    const title = query.title || hashQuery.title || ''
    const id = query.pop_id || hashQuery.pop_id || ''
    next(vm => {
      if (title) {
        vm.title = title
        document.title = title
      } else {
        vm.title = '店铺详情'
      }
      const promises = []
      if (!vm.$store.state.pop.shop.id) {
        vm.$store.commit('pop/updateShopId', id)
        promises.push(vm.getPopShop())
      }
      promises.push(vm.getPopQualificationInfo())
      Promise.all(promises)
        .then(res => {})
        .catch(err => {
          if (Array.isArray(err)) {
            err.forEach(e => {
              vm.$catch(e)
            })
          } else {
            vm.$catch(err)
          }
        })
    })
  },
  data() {
    return {
      title: '店铺详情',
      browerInfo: window.matrix
    }
  },
  computed: {
    ...mapState('pop', ['shop', 'qualification', 'personShopInfo']),
    bizClassText() {
      const classText = this.qualification.bizClass.reduce(
        (accumulator, item, index) => {
          if (item.className) {
            return `${accumulator}${!index ? '' : ' '}${item.className}`
          } else {
            return accumulator
          }
        },
        ''
      )
      return classText
    },
    pagePaddingTop() {
      if (!miniProgramEnv.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    }
  },
  methods: {
    ...mapActions('pop', ['getPopShop', 'getPopQualificationInfo']),
    goBack() {
      this.$back()
    },
    goLicense(type) {
      this.$router.push({
        name: 'popLicense',
        query: {
          pop_id: this.shop.id,
          type
        }
      })
    },
    goPersonShopInfo() {
      this.$router.push({
        name: 'popPersonShopInfo'
      })
    }
  }
}
</script>
